import React, { useState } from "react";
import { FiChevronDown, FiChevronRight } from "react-icons/fi";

const FieldRow = ({ label, value, className = "" }) => (
  <div className={`flex items-baseline gap-1.5 ${className}`}>
    <span className="text-gray-500 shrink-0">{label}:</span>
    <span className="font-medium text-gray-700">{value || "-"}</span>
  </div>
);

// Desktop (unchanged): every field from `fields` in a single row.
// Mobile: a tappable summary card (title + subtitle + chevron) that expands
// into `mobileFields` (falls back to `fields`) plus an optional footer line,
// instead of either scrolling sideways or dumping every field on screen.
const ExpandableInfoPanel = ({
  fields,
  title,
  subtitle,
  mobileFields,
  footer,
  endAction,
}) => {
  const [expanded, setExpanded] = useState(false);
  const expandedFields = mobileFields || fields;

  return (
    <div className="border rounded-md mb-4 text-sm bg-gray-50 md:bg-gray-50">
      {/* Desktop: single row, all fields, optional trailing action */}
      <div className="hidden md:flex md:flex-nowrap md:items-center gap-x-5 overflow-x-auto px-4 py-2.5">
        {fields.map((field) => (
          <FieldRow key={field.label} {...field} className="shrink-0 whitespace-nowrap" />
        ))}
        {endAction && <div className="ml-auto shrink-0">{endAction}</div>}
      </div>

      {/* Mobile: expandable summary card */}
      <div className="md:hidden">
        <button
          type="button"
          className="w-full flex items-center justify-between gap-3 px-4 py-3 text-left"
          onClick={() => setExpanded((prev) => !prev)}
        >
          <div className="min-w-0">
            <div className="font-semibold text-secondary truncate">{title || "-"}</div>
            {subtitle && (
              <div className="text-xs text-gray-500 truncate mt-0.5">{subtitle}</div>
            )}
          </div>
          <span className="text-gray-400 shrink-0">
            {expanded ? <FiChevronDown size={18} /> : <FiChevronRight size={18} />}
          </span>
        </button>

        {expanded && (
          <div className="px-4 pb-3 space-y-2">
            {expandedFields.map((field) => (
              <div key={field.label} className="flex justify-between gap-3">
                <span className="text-gray-500">{field.label}</span>
                <span className="font-medium text-gray-700 text-right">
                  {field.value || "-"}
                </span>
              </div>
            ))}
            {footer && (
              <div className="border-t pt-2 text-xs text-gray-500">{footer}</div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default ExpandableInfoPanel;
